/**
 * Configuración de AWS Amplify
 *
 * IMPORTANTE: Después de deployar el servicio auth, actualizar estos valores
 * con los outputs de CloudFormation:
 * - UserPoolId
 * - UserPoolClientId
 * - Region
 */

// NER-3781: el OAuth social de Google se resuelve fuera de Cognito, vía el
// flujo custom de services/social-auth (NER-3785): no se usa el Hosted UI de
// Cognito (approach CANCELLED en NER-3782/3783). Por eso este config queda como
// email/password puro; el botón "Continuar con Google" (GoogleSignInButton)
// redirige directo al backend, sin pasar por Amplify.
const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_zztd1R3kI',
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '2fegr7sj16kuqcrn8hcsq1vk5o',
      region: 'us-east-1',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
      },
      userAttributes: {
        email: {
          required: true,
        },
        name: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
};

export default awsConfig;
